import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../../../../util/lodash";
import React from 'react';
import classnames from 'classnames';
import { createComponent, PropTypes } from "../../../../wayin-react";
import { sizes, socialSharings } from "../../../../enums";
import { ConfigService } from "../../../../services";
import SharingConstants from "../constants";
import Image from "../../../core/image";
var SharingContent = createComponent({
  displayName: 'SharingContent',
  propTypes: {
    network: PropTypes.string.isRequired,
    title: PropTypes.string,
    byline: PropTypes.string,
    message: PropTypes.string
  },
  defaultProps: {
    network: 'default',
    title: '{Title}',
    byline: '{Byline}',
    message: '{Caption}'
  },
  render: function render(p) {
    var _classnames, _classnames2, _classnames3;

    return /*#__PURE__*/React.createElement("div", {
      className: "middle aligned content sharing-story"
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('title', (_classnames = {}, _classnames['content-placeholder'] = !p.title, _classnames))
    }, p.title || '{Title}'), /*#__PURE__*/React.createElement("div", {
      className: classnames('byline', (_classnames2 = {}, _classnames2['content-placeholder'] = !p.byline, _classnames2))
    }, p.byline || '{Byline}'), /*#__PURE__*/React.createElement("div", {
      className: classnames('caption', (_classnames3 = {}, _classnames3['content-placeholder'] = !p.message, _classnames3))
    }, p.message || (p.network == socialSharings.TWITTER ? '{Post}' : '{Caption}')));
  }
});
var Logo = createComponent({
  displayName: 'SharingNetworkLogo',
  propTypes: {
    network: PropTypes.string,
    // tiny, small, medium or large only
    size: PropTypes.oneOf(_.without(sizes.ALL, sizes.X1, sizes.X6, sizes.X7, sizes.X8))
  },
  defaultProps: {
    network: 'default',
    size: sizes.S
  },
  render: function render(p) {
    var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

    return /*#__PURE__*/React.createElement(Image, {
      src: ConsoleKitConfig.assetUrls.assetFolderPath + "misc/" + p.network + "-logo-" + p.size + ".png"
    });
  }
});

var Avatar = function Avatar(p) {
  var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

  return /*#__PURE__*/React.createElement(Item, {
    className: "sharing-avatar avatar-" + p.network
  }, /*#__PURE__*/React.createElement(Image, {
    src: "" + ConsoleKitConfig.assetUrls.assetFolderPath + SharingConstants.PREVIEW_CONFIG[p.name].avatar
  }), /*#__PURE__*/React.createElement("div", {
    className: "middle aligned content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, p.title), /*#__PURE__*/React.createElement("div", {
    className: "byline"
  }, p.byline)));
};

var SharingImage = function SharingImage(p) {
  return /*#__PURE__*/React.createElement(Layout.Row, {
    columnStyles: {
      textAlign: textAlignments.CENTER
    }
  }, /*#__PURE__*/React.createElement(Layout.Column, null, /*#__PURE__*/React.createElement("img", {
    className: "sharing-image",
    src: p.src
  })));
};

var Item = function Item(p) {
  var _classnames4;

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('ui items', (_classnames4 = {}, _classnames4[p.className] = p.className, _classnames4))
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, p.children));
};

var MessagePlaceholder = function MessagePlaceholder(p) {
  return /*#__PURE__*/React.createElement("div", {
    className: "messagePlaceholder"
  }, p.text);
};

var NetworkActions = function NetworkActions(p) {
  var _classnames5;

  var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('sharing-actions', (_classnames5 = {}, _classnames5["sharing-actions-" + p.network] = p.network, _classnames5))
  }, /*#__PURE__*/React.createElement(Image, {
    src: ConsoleKitConfig.assetUrls.assetFolderPath + "misc/" + p.network + "-actions.png"
  }));
};

export { SharingContent, Avatar, Logo, SharingImage, Item, MessagePlaceholder, NetworkActions };
//# sourceMappingURL=common.js.map